import { useEffect, useState } from 'react';

export const useAlertVisible = (searchedInvalidGenes: string[]) => {
  const [shouldShowAlert, setShouldShowAlert] = useState(true);

  useEffect(() => {
    if (searchedInvalidGenes.length > 0) {
      setShouldShowAlert(true);
    }
  }, [searchedInvalidGenes]);

  const closeAlertBar = () => {
    setShouldShowAlert(false);
  };

  const isAlertVisible = searchedInvalidGenes.length > 0 && shouldShowAlert;

  return { isAlertVisible, closeAlertBar };
};
